// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var CanvasImageKey;
(function (CanvasImageKey) {
    CanvasImageKey["SortUp"] = "sortUp";
    CanvasImageKey["SortDown"] = "sortDown";
    CanvasImageKey["CloseBtn"] = "closeBtn";
    CanvasImageKey["CloseViaOEBtn"] = "closeViaOEBtn";
    CanvasImageKey["PlaceBtn"] = "placeBtn";
    CanvasImageKey["SellAssetBtn"] = "sellAssetBtn";
    CanvasImageKey["ShowOnChartBtn"] = "showOnChartBtn";
    CanvasImageKey["SettingsBtn"] = "settingsBtn";
    CanvasImageKey["ToBeginBtn"] = "toBeginBtn";
    CanvasImageKey["ZoomInBtn"] = "zoomInBtn";
    CanvasImageKey["ZoomOutBtn"] = "zoomOutBtn";
    CanvasImageKey["PositionOnChartIcon"] = "positionOnChartIcon";
    CanvasImageKey["OrderOnChart"] = "orderOnChart";
    CanvasImageKey["LinkOrderOnChart"] = "linkOrderOnChart";
    CanvasImageKey["CloseIcon"] = "closeIcon";
    CanvasImageKey["ThreeDotsMenu"] = "threeDotsMenu";
    CanvasImageKey["TrailingBtn"] = "trailingBtn";
    CanvasImageKey["AlertIcon"] = "alertIcon";
    CanvasImageKey["AlertEdit"] = "alertEdit";
    CanvasImageKey["VisibleData"] = "visibleData";
    CanvasImageKey["InvisibleData"] = "invisibleData";
    CanvasImageKey["ArrowUp"] = "arrowUp";
    CanvasImageKey["ArrowDown"] = "arrowDown";
    CanvasImageKey["ArrowLeft"] = "arrowLeft";
    CanvasImageKey["ArrowRight"] = "arrowRight";
    CanvasImageKey["MoreIcon"] = "moreIcon";
    CanvasImageKey["UserGroup"] = "userGroup";
    CanvasImageKey["LinkedAccounts"] = "linkedAccounts";
    CanvasImageKey["Account"] = "account";
    CanvasImageKey["InfoIcon"] = "infoIcon";
    CanvasImageKey["Checkbox"] = "checkBox";
    CanvasImageKey["ScaleSelectorAbsolute"] = "scaleSelectorAbsolute";
    CanvasImageKey["ScaleSelectorRelative"] = "scaleSelectorRelative";
    CanvasImageKey["ScaleSelectorLog"] = "scaleSelectorLog";
    CanvasImageKey["DelayIcon"] = "delayIcon";
    CanvasImageKey["ChartIcon"] = "chartIcon";
    CanvasImageKey["HeatmapIcon"] = "heatmapIcon";
    CanvasImageKey["ApplyIcon"] = "applyIcon";
    CanvasImageKey["Overnight"] = "overnight";
    CanvasImageKey["Minus"] = "minus";
    CanvasImageKey["Plus"] = "plus";
})(CanvasImageKey || (CanvasImageKey = {}));
export class CanvasImage {
    constructor(key, color, opacity = 1) {
        this.key = key;
        this.color = color;
        this.opacity = opacity;
    }
}
